/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ConfirmationDialog from '../../molecules/ConfirmationDialog/ConfirmationDialog';
import { hideConfirmationDialog } from '../../redux-actions/actionsApp';
import './ConfirmationDialogOverlay.scss';

class ConfirmationDialogOverlay extends Component {
  handleOnConfirm = () => {
    const { options, dispatch } = this.props;

    if (typeof options.onConfirm === 'function') {
      options.onConfirm();
    }

    dispatch(hideConfirmationDialog());
  };

  handleOnCancel = () => {
    const { options, dispatch } = this.props;

    if (typeof options.onCancel === 'function') {
      options.onCancel();
    }

    dispatch(hideConfirmationDialog());
  };

  render() {
    const { visible, options } = this.props;

    if (!visible) {
      return null;
    }

    return (
      <div className="confirmation-dialog-overlay">
        <ConfirmationDialog
          heading={options.heading}
          text={options.text}
          confirmLabel={options.confirmLabel || 'Confirm'}
          cancelLabel={options.cancelLabel || 'Cancel'}
          onConfirm={this.handleOnConfirm}
          onCancel={this.handleOnCancel}
          customInput={options.customInput || null}
        />
      </div>
    );
  }
}

ConfirmationDialogOverlay.propTypes = {
  visible: PropTypes.bool,
  options: PropTypes.shape({
    heading: PropTypes.string,
    text: PropTypes.string,
    confirmLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    customInput: PropTypes.shape({
      placeholder: PropTypes.string,
      value: PropTypes.string.isRequired,
      onChange: PropTypes.func.isRequired,
    }),
  }),
  dispatch: PropTypes.func,
};

ConfirmationDialogOverlay.defaultProps = {
  visible: false,
  options: {},
  dispatch: () => false,
};

const mapStateToProps = ({ appState }) => ({
  visible: appState.confirmationDialogVisible,
  options: appState.confirmationDialogOptions || {},
});

export default connect(mapStateToProps)(ConfirmationDialogOverlay);
